import React from 'react';
import { Box } from '@chakra-ui/react';

const HeaderFont = ({ children, ...props }) => {
  return (
    <Box fontFamily="'AvenirNextCondensed', Arial, sans-serif" {...props}>
      {children}
    </Box>
  );
};

export default HeaderFont;
